/** Validation SIRET côté saisie : 14 chiffres + clé de Luhn (exception La Poste : SIREN 356000000, somme multiple de 5). */
const LA_POSTE = "356000000";

export const cleanSiret = (v) => String(v || "").replace(/\D/g, "");

export const formatSiret = (v) => {
  const d = cleanSiret(v).slice(0, 14);
  return [d.slice(0, 3), d.slice(3, 6), d.slice(6, 9), d.slice(9)].filter(Boolean).join(" ");
};

const luhnOk = (digits) => {
  let total = 0;
  for (let i = 0; i < digits.length; i += 1) {
    let d = Number(digits[digits.length - 1 - i]);
    if (i % 2 === 1) { d *= 2; if (d > 9) d -= 9; }
    total += d;
  }
  return total % 10 === 0;
};

/** Retourne { state: "empty" | "partial" | "invalid" | "valid", message, cleaned, formatted }. */
export const validateSiret = (value) => {
  const raw = String(value || "").trim();
  const cleaned = cleanSiret(raw);
  if (!raw) return { state: "empty", message: "", cleaned, formatted: "" };
  if (/[^\d\s.-]/.test(raw)) return { state: "invalid", message: "Le SIRET ne contient que des chiffres (espaces tolérés).", cleaned, formatted: formatSiret(cleaned) };
  if (cleaned.length < 14) return { state: "partial", message: `${cleaned.length}/14 chiffres`, cleaned, formatted: formatSiret(cleaned) };
  if (cleaned.length > 14) return { state: "invalid", message: `14 chiffres attendus (${cleaned.length} saisis).`, cleaned, formatted: formatSiret(cleaned) };
  const ok = cleaned.startsWith(LA_POSTE) ? cleaned.split("").reduce((s, c) => s + Number(c), 0) % 5 === 0 : luhnOk(cleaned);
  if (!ok) return { state: "invalid", message: "Clé de contrôle (Luhn) incorrecte — vérifiez la saisie (un chiffre inversé ou manquant ?).", cleaned, formatted: formatSiret(cleaned) };
  return { state: "valid", message: `SIRET valide · SIREN ${cleaned.slice(0, 9)} · NIC ${cleaned.slice(9)}`, cleaned, formatted: formatSiret(cleaned) };
};
